import { computed } from "vue";
import type { IPriceBreakdownProps } from "~/components/price-breakdown/props";
import { useBasketStore } from "~/stores/basket";
import { useOutletStore } from "~/stores/outlet";

export function usePriceBreakdownProps() {
  const basket = useBasketStore();
  const outlet = useOutletStore();

  return computed<Omit<IPriceBreakdownProps, "hideFinalTotal">>(() => ({
    discountedAmount: basket.totalBreakdown.discountedAmount,
    deliveryFee: basket.totalBreakdown.deliveryFee,
    productsTotal: basket.totalBreakdown.basketTotal,
    loyaltyRedeemed: basket.totalBreakdown.loyaltyRedeemed,
    taxAmount: basket.totalBreakdown.taxAmount,
    serviceCharges: basket.totalBreakdown.serviceCharges,
    bagFee: basket.totalBreakdown.bagFee,
    subtotal: basket.totalBreakdown.subtotal,
    total: basket.totalBreakdown.outstandingBalance,
    giftCard: basket.giftCardPayment,
    outstandingBalance: basket.totalBreakdown.outstandingBalance,
    isTaxIncluded: outlet.isTaxIncluded,
  }));
}
